'use strict';

define(['jquery', 'app', 'siteObj'], function ($, app, siteObj) {

  var list_items = [],
      list_height = 0,
      list_item_height;

  var _brandSelect = {

    _init: function _init() {
      var config = {
        brandsNav: $('.brands-nav'),

        /* used to the calculate the height of the drop down */

        viewableListItems: 10,

        /* variable classes passed to on event listeners */

        viewSelector: '.brand-view',
        nameSelector: '.brand-name',
        inputSelector: '.brands-input:text',
        activeSelector: '.active',
        selectedSelector: '.selected',

        /* toggle classes */

        activeClass: 'active',
        selectedClass: 'selected'

      };

      _brandSelect._bindEvents(config);

      return app.ajax.get({
        url: '/' + siteObj.customerLocale + '/' + siteObj.currencyType + '/brands.nav',
        dataType: 'JSON',
        success: function success(result) {
          $('.brands-nav-list').html(result);
        },
        error: function error(e) {
          console.error(e.message, e);
        }
      });
    },

    _viewClickCallback: function _viewClickCallback(config) {
      if (!config.brandsNav[0].querySelectorAll('ul.brands-list li').length) {
        if (siteObj.props.deferComponents.brands) {
          window.location.href = siteObj.props.deferComponents.brands;
        }
        return;
      }

      var toggle = config.brandsNav;
      var input = config.brandsNav.find(config.inputSelector);
      list_items = config.brandsNav.find(config.nameSelector).parent();

      toggle.toggleClass(config.activeClass);
      list_items.addClass(config.activeClass);

      /* define height variables once list items are active */

      list_item_height = list_items.height();
      list_height = list_item_height * config.viewableListItems;

      list_items.parent().css('max-height', list_height + 'px');

      /* clear any previous search queries and selections */

      var find_selected = list_items.filter(config.selectedSelector);

      input.val('');
      find_selected.removeClass('selected');
      list_items.parent().scrollTop(0);
      input.focus();
    },

    _nameClickCallback: function _nameClickCallback(config, element) {
      /* store the clicked brand in val so that the view can be updated */
      var toggle = config.brandsNav;
      var view = config.brandsNav.find(config.viewSelector);
      var val = element.text();

      view.text(val);
      toggle.toggleClass(config.activeClass);
    },

    _regexFilter: function _regexFilter(selector) {
      return selector.text().replace(/é/g, 'e').replace(/-/g, '').replace(/\s+|\s+/g, '').replace(/\b\s/g, '').replace(/'/g, '').replace(/\s/g, '').replace(/[A-Z]/g, function (match) {
        return match.toLowerCase();
      }).substring(0, window.filter.length);
    },

    _bindEvents: function _bindEvents(config) {
      var toggle = config.brandsNav;
      config.brandsNav.on('click', config.viewSelector, function () {
        _brandSelect._viewClickCallback(config);
        var $body = $('body');

        if (config.brandsNav.hasClass(config.activeClass)) {
          // send tracking events
          app.publish('tracking/record', 'Navigation Header', 'Clicked Brand Search');
          var brandsClick = false;
          $body.on('click', function () {
            if (brandsClick) {
              return;
            }
            config.brandsNav.removeClass(config.activeClass);
            $body.off('click');
            return false;
          });

          config.brandsNav.on('click', function () {
            brandsClick = true;
          });
          return false;
        }
      });

      config.brandsNav.on('click', config.nameSelector, function () {
        _brandSelect._nameClickCallback(config, $(this));
      });

      /*
       /* ON KEY EVENTS */
      /* logic for search filtering and keyboard navigation with scrolling
         /* prevent default 'up' key behaviour on input */

      config.brandsNav.on('keydown', config.inputSelector, function (e) {
        if (e.key === 'ArrowUp' || e.key === 'Up') {
          return false;
        }
      });

      config.brandsNav.on('keyup', config.inputSelector, function (e) {

        // var key = e.key;
        var current, index, link, val, scroll_offset;

        var length = String($(this).val()).length;
        window.filter = $(this).val().replace(/\s/g, ''); // Remove spaces
        var filtered_list = list_items.filter(config.activeSelector);
        var selected = filtered_list.filter(config.selectedSelector);

        filtered_list.length > 0 ? window.scroll_height = config.brandsNav.find(config.activeSelector).parent()[0].scrollHeight : false;

        if (length < 1) {
          list_items.addClass(config.activeClass);
          filtered_list.removeClass(config.selectedClass);
        }

        if (length > 0) {
          list_items.removeClass(config.activeClass);
          filtered_list.removeClass(config.selectedClass);
        }

        /* loop through list items to check for matches
         and turn back on the active states when matches are found */

        $(config.nameSelector).each(function () {

          var result = _brandSelect._regexFilter($(this)) === window.filter.toLowerCase();

          /* also check against the url for matches */

          if (result === false && result !== 'undefined') {
            window.url = this.getAttribute('href');
            window.startPos = window.url.lastIndexOf('/') + 1;
            result = window.url.slice(window.startPos).replace('-', '').replace(/-/g, ' ').substring(0, window.filter.length) === window.filter;
          }

          result === true ? $(this).parent().addClass(config.activeClass) : false;
        });

        /* reset selection if mouse scroll detected */

        config.brandsNav.on('mousewheel', list_height, function () {
          filtered_list.removeClass(config.selectedClass);
        });

        /* reset selection if user clicks the input field */

        config.brandsNav.on('click', config.inputSelector, function () {
          filtered_list.removeClass(config.selectedClass);
        });

        /* follow link and update view on enter key press */

        /* when a selection is made using the up/down arrows */

        var view = config.brandsNav.find(config.viewSelector);

        if (e.key === 'Enter' && selected.length !== 0) {
          link = selected.find('a').attr('href');
          val = selected.text();

          if (val.length !== 0 && link !== 'undefined') {
            view.text(val);
            window.location.href = link;
          }

          toggle.toggleClass(config.activeClass);
        }

        /*  automatically selects the first item in the filtered list when no selection is made using the up/down arrows  */

        if (e.key === 'Enter' && selected.length === 0) {
          link = filtered_list.find('a').attr('href');
          var array = filtered_list.filter(':first');
          val = array.text();

          if (val.length !== 0 && link !== 'undefined') {
            view.text(val);
            window.location.href = link;
          }

          toggle.toggleClass(config.activeClass);
        }

        if (e.key === 'ArrowUp' && e.key === 'Up' && e.key === 'ArrowDown' && e.key === 'Down') {
          return;
        }

        filtered_list.removeClass(config.selectedClass);

        var scroll_pos = list_items.parent().scrollTop();

        if (e.key === 'ArrowDown' || e.key === 'Down') {

          !selected.length ? current = filtered_list.eq(0) : current = selected.nextAll(config.activeSelector).first();

          index = current.index(config.activeSelector);

          scroll_offset = index * list_item_height - (list_height + list_item_height);

          config.brandsNav.find(config.activeSelector).parent().scrollTop(scroll_offset += list_item_height);

          if (index === -1) {
            current = selected;
            config.brandsNav.find(config.activeSelector).parent().scrollTop(window.scroll_height);
          }
        } else if (e.key === 'ArrowUp' || e.key === 'Up') {

          !selected.length ? current = filtered_list.last() : current = selected.prevAll(config.activeSelector).first();

          index = current.index(config.activeSelector);
          scroll_offset = index * list_item_height;

          index === -1 ? current = selected : false;

          index * list_item_height < list_height * list_item_height && scroll_pos !== 0 || index === 1 ? config.brandsNav.find(config.activeSelector).parent().scrollTop(scroll_offset -= list_item_height) : false;
        }

        current.addClass(config.selectedClass);
      });
    }
  };

  _brandSelect._init();
  return _brandSelect;
});
//# sourceMappingURL=brands-selection.js.map
